/*=====================================
    SystemTextMsgDialog

    Author: Ac
    CreateTime: 2018 / 11 / 23
=====================================*/

/*--------------------------
    Import
--------------------------*/
import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from 'actions/creators';
import styled from 'styled-components';
import { GlobalStyle, Colors, DialogStyle } from 'stylecomponents';
import TimeFormat from 'components/commons/TimeFormat';
import CupoyNoteContent from '../commons/CupoyNoteContent';
import MarkdownContentView from 'cupoy-md-editor/lib/preview';

/*--------------------------
    Styled
--------------------------*/
const Title = styled.div`
    font-size: 23px;
    color: #4A4A4A;
    font-weight: 600;
    text-align: center;
    padding-bottom: 30px;
    border-bottom: 1px solid #D9D9D9;
`;
const List = styled.ul`
    margin: 0;
`;
const ListItem = styled.li`
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid #EEE;
    font-size: 15px;
    line-height: 20px;
    padding: 20px 0;
`;
const Text = styled.div`
    flex: 1;
    word-break: break-all;
    color: ${Colors.Dark3};
    padding-right: 10px;

    img {
        max-width: 100%;
    }
`;
const Time = styled.div`
    min-width: 155px;
    color: ${Colors.Dark5};
    margin-left: auto;
    margin-top: auto;
`;
const Btn = GlobalStyle.BasicBtn.extend`
    width: 150px;
    margin: 40px auto 0;
`;
/*--------------------------
    Main Component
--------------------------*/
class SystemTextMsgDialog extends PureComponent {

    closeDialog = () => {
        this.props.webActions.closeSystemTextMsgDialog();
    }

    render() {

        const { unreadSystemTextMsgList = [] } = this.props;

        return (
            <DialogStyle.Content
                // style props
                maxWidth="660px"
                width='660px'
                margin="90px auto 20px"
                padding="40px"
                borderRadius="3px"
                // dialog props
                visible
                animation="zoom"
                maskAnimation="fade"
                closable={false}
                className="signup-modal"
                onClose={this.closeDialog}
            >
                <DialogStyle.CloseButton onClick={this.closeDialog}>
                    <i className="zmdi zmdi-close"></i>
                </DialogStyle.CloseButton>
                <Title>登入訊息通知</Title>

                <List>
                    {unreadSystemTextMsgList.map(textMsg => {

                        const {
                            msgid,
                            content,
                            createtime,
                            note_editor_type,
                            markdown
                        } = textMsg;

                        return (
                            <ListItem key={msgid}>
                                <Text>
                                    {note_editor_type === 1 ?
                                        <MarkdownContentView mdcontent={markdown} />      
                                        : <CupoyNoteContent html={content} />
                                    }
                                </Text>
                                <Time>
                                    <TimeFormat
                                        format='simpleFullTime'
                                        time={createtime}
                                    />
                                </Time>
                            </ListItem>
                        );
                    })}
                </List>
                
                <Btn onClick={this.closeDialog}>關閉</Btn>
            </DialogStyle.Content>
        );
    }
}

/*--------------------------
    Reducer Props
--------------------------*/
const mapStateToProps = function(state) {
    return {
        unreadSystemTextMsgList: state.web.systemTextMsgDialog.unreadSystemTextMsgList,
    };
};

/*--------------------------
    Reducer Action
--------------------------*/
const mapActionToProps = function(dispatch) {
    return {
        webActions: bindActionCreators(actionCreators.webActionCreators, dispatch),
    };
};

/*--------------------------
    Export
--------------------------*/
export default connect(mapStateToProps, mapActionToProps, null, {
    forwardRef: true
})(SystemTextMsgDialog);